const routes = [
  {
    path: '/carResearch', // 人员名单管理
    name: 'carResearch',
    component: () => import('./view/Index.vue'),
    meta: {
      requireAuth: false,
      // routerAlive: true
    }
  }
]

export default routes